import Vue from 'vue'   //引入Vue
import Router from 'vue-router'

import Login from '@/components/Login'
import Index from '@/components/Index'
import ProdEditor from '@/components/ProdEditor'
import EntEditor from '@/components/EntEditor'
import EntDealer from '@/components/EntDealer'
import EntDealerEdit from '@/components/EntDealerEdit'
import EntDealerView from '@/components/EntDealerView'
import ProdView from '@/components/ProdView'
import AfcodeDown from '@/components/AfcodeDown'
import AfcodeList from '@/components/AfcodeList'
import About from '@/components/About'
import UserPwd from '@/components/UserPwd'
import UserRegister from '@/components/UserRegister'
import SalesChooseDealer from '@/components/SalesChooseDealer'
import SalesDeliver from '@/components/SalesDeliver'

Vue.use(Router)  //Vue全局使用Router

export default new Router({
    routes: [{
        path: '/',
        component: Index
    }, {
        path: '/login',
        component: Login
    }, {
        path: '/index/:view',
        component: Index
    }, {
        path: '/prod/edit',
        component: ProdEditor,
        props: (route) => ({prodId: route.query.id})
    }, {
        path: '/prod/view',
        component: ProdView,
        props: (route) => ({prodId: route.query.id})
    }, {
        path: '/prod/afcode/down',
        component: AfcodeDown,
        props: (route) => ({prodId: route.query.id, pkgNum: route.query.pkgNum})
    }, {
        path: '/prod/afcode/record',
        component: AfcodeList,
        props: (route) => ({prodId: route.query.id})
    }, {
        path: '/ent/edit',
        component: EntEditor
    }, {
        path: "/ent/dealer",
        component: EntDealer
    }, {
        path: "/ent/dealer/edit",
        component: EntDealerEdit,
        props: (route) => ({dealerId: route.query.id})
    }, {
        path: "/ent/dealer/view",
        component: EntDealerView,
        props: (route) => ({dealerId: route.query.id})
    }, {
        path: '/about',
        component: About
    }, {
        path: '/user/pwd',
        component: UserPwd
    }, {
        path: '/user/register',
        component: UserRegister
    },{
        path: '/ent/sales/choose_dealer',
        component: SalesChooseDealer
    },{
        name: 'salesDeliver',
        path: '/ent/sales/deliver',
        component: SalesDeliver,
        props: true
    }]
})